import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeClassReadAction from './cnaeClassRead.action.json' with { type: 'json' }

const cnaeClassReadDefinition = defineReadAutoAction(cnaeClassReadAction, 'cnaeClass')

export default cnaeClassReadDefinition
